// extracted by mini-css-extract-plugin
module.exports = {"resource":"resource___2Mzuw","object":"object___1_FJQ","exhibit":"exhibit___1c-m6"};